module.exports = __webpack_public_path__ + "static/img/tab-home-none.cc25e97.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tab-home-none.png
// module id = 7G3b
// module chunks = 1